var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWg3DView({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2489 8.77283C2.26378 9.74835 1 11.2188 1 12.8637C1 15.9223 5.238 17.9416 9.82514 18.1858M15.7511 8.77283C17.7362 9.74835 19 11.2188 19 12.8637C19 14.0022 18.3946 15.0572 17.3636 15.9223C16.4692 16.6728 15.2544 17.2805 13.8367 17.6759",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0005 14.0909V6.81818M10.0005 14.0909L15.7277 11.1818V3.90909M10.0005 14.0909L4.27319 11.1818V3.90909M10.0005 6.81818L15.7277 3.90909M10.0005 6.81818L4.27319 3.90909M15.7277 3.90909L10.0005 1L4.27319 3.90909",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43164 15.8634L10.754 18.1858L8.43164 20.5082",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWg3DView);
export default __webpack_public_path__ + "static/media/wg-3d-view.96512e35f4d147da6d9e123d9d507094.svg";
export { ForwardRef as ReactComponent };